import type { RouteRecordRaw } from 'vue-router'
import PageHome from '@/views/app/home/page-home.vue'
import LayoutApp from '@/views/app/the-layout.vue'
import AuthRoutes from './modules/auth'
import BuybackRoutes from './modules/buyback'
import ErrorRoutes from './modules/error'
import PasswordRoutes from './modules/password'
import ProductRoutes from './modules/product'
import ProductUnitRoutes from './modules/product-unit'
import RoleRoutes from './modules/role'
import SaleRoutes from './modules/sale'
import UserAdminRoutes from './modules/useradmin'

const routes: RouteRecordRaw[] = [
  layoutApp('/home', [
    {
      path: '/',
      name: 'home',
      component: PageHome,
      meta: { title: 'Dashboard' },
    },
    {
      path: '/riwayat-perubahan',
      name: 'changelogs',
      component: () => import('@/views/app/changelog/page-list.vue'),
      meta: { title: 'Riwayat Perubahan' },
    },
    {
      path: '/css',
      name: 'css',
      component: () => import('@/views/app/css/page-index.vue'),
      meta: { title: 'CSS' },
    },
  ]),

  layoutApp('/pengguna', UserAdminRoutes),
  layoutApp('/hak-akses', RoleRoutes),
  layoutApp('/ubah-password', PasswordRoutes),
  layoutApp('/produk', ProductRoutes),
  layoutApp('/produk-unit', ProductUnitRoutes),
  layoutApp('/sale', SaleRoutes),
  layoutApp('/buyback', BuybackRoutes),

  {
    path: '/cetak/qrcode',
    name: 'print qrcode',
    component: () => import('@/views/print/qrcode/page-qrcode.vue'),
    meta: { title: 'Cetak QR Code' },
  },

  AuthRoutes,
  ErrorRoutes,
]

export function layoutApp (path: string, children: RouteRecordRaw[]): RouteRecordRaw {
  return {
    path,
    children,
    component: LayoutApp,
  }
}

export default routes
